import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-games'

export const getGameCutoffPolicy = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-cutoff-policy`, { id }, {
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
    })
    return response.data
}

export const saveGameCutoffPolicyDraft = async (token, payload) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-cutoff-policy`, payload, {
        headers: { 'Content-Type': 'application/json', 'Authorization': token },
    })
    return response.data
}

export const getAllGames = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getGameGuide = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-guide`, {
        id,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data?.guide || null
    }
    return null
}

export const updateStatus = async (token, id, newStatus) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-status`, {
        id: id,
        status: newStatus
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateOrderNumber = async (token, id, newOrderNumber) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-order-number`, {
        id: id,
        orderNumber: newOrderNumber
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateGuide = async (token, id, guideId, content, gameId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-guide`, {
        id: id,
        guideId: guideId || 0,
        content: content,
        gameId: gameId,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const uploadIcon = async (token, kind, target, file) => {
    const formData = new FormData()
    formData.append('kind', kind)
    formData.append('target', target)
    formData.append('image', file)

    const response = await axios.post(`${host}/${PLUGINS_NAME}/upload-icon`, formData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
            'Authorization': token,
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateCutoffOffset = async (token, id, cutoffOffsetSeconds) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-cutoff-offset`, {
        id: id,
        cutoffOffsetSeconds: cutoffOffsetSeconds === '' || cutoffOffsetSeconds == null ? null : Number(cutoffOffsetSeconds),
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateCutoffTime = async (token, id, cutoffTime) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-cutoff`, {
        id: id,
        cutoffTime: cutoffTime || '',
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updatePrintCutoffTime = async (token, id, printCutoffTime) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-print-cutoff`, {
        id: id,
        printCutoffTime: printCutoffTime || '',
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateIcon = async (token, id, icon) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-icon`, {
        id: id,
        icon: icon || '',
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}
